import MobileDetect from 'mobile-detect';

export const isDesktop = () => {
    const isNotDesktop = window.matchMedia('only screen and (max-width: 1300px)').matches;
    const md = new MobileDetect(window.navigator.userAgent);

    return !(md.mobile() || md.phone() || md.tablet() || isNotDesktop);
};
